{
  "name": "12-Subharmonic (Elsie Hamilton) 19-Limit",
  "description": "12-tone 19-Limit Rational Intonation (JI) scale. Derived from the subharmonic partial row, it is limited to partials u12-u25 under F-comma-up, skipping 23°.",
  "scale": [
    "12/11",
    "8/7",
    "6/5",
    "24/19",
    "4/3",
    "24/17",
    "3/2",
    "8/5",
    "12/7",
    "24/13",
    "48/25",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "12-HamiltonModes",
  "built_in_group": "12 Note Scales",
  "key_labels": "note_names",
  "note_names": ["B", "C", "C", "D", "D", "E", "F", "F", "G", "G", "A", "B"],
  "note_colors": [
    "#ff8f8f",
    "#b6e8a1",
    "#eecbc9",
    "#beb58f",
    "#d4eff2",
    "#c7c1a1",
    "#cdcdc9",
    "#e9e1b4",
    "#beb58f",
    "#eecbc9",
    "#ddcce6",
    "#e7e1c8"
  ],
  "equivSteps": 12,
  "fundamental": 352,
  "reference_degree": 7,
  "center_degree": 7,
  "rSteps": 2,
  "drSteps": 1,
  "hexSize": 42,
  "rotation": -16.102113751
}
